import createIcon from '../../createIcon';

/**
 * @component @name SignalCellular0Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgNi44M1YyMEg2LjgzTDIwIDYuODNaTTIyIDJMMiAyMkgyMlYyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SignalCellular0Bar = createIcon('SignalCellular0Bar', [
  ['path', { d: 'M20 6.83V20H6.83L20 6.83ZM22 2L2 22H22V2Z', key: '14huql' }],
]);

export default SignalCellular0Bar;
